import './Accordeon.scss'
import { useState, useRef } from 'react'


export default function Accordeon({title, body}){

    const [isVisible, setIsVisible] = useState(false)
    const contentRef = useRef(null);

    const openAccordeon = () => {
        setIsVisible(!isVisible)
    }

    return(
        <div className="Accordeon">
            <div className="accordeon_item">
                <div onClick={openAccordeon} className="accordeon_title">
                    <h3>{title}</h3>
                    {(!isVisible) ? <img src="./arrow.svg" alt="open arrow" /> : <img src="./arrow-up.svg" alt="open arrow" />}
                    
                </div>

                <div ref={contentRef} style={{
                    maxHeight: isVisible ? `${contentRef.current?.scrollHeight}px` : '0px',
                    opacity: isVisible ? 1 : 0
                    }} className="accordeon_body">
                    {body}
                </div> 
                
            </div>
        </div>
    )
}